import { lazy } from 'react';

const PaymentForecastPage = lazy(() => import('@/pages/payment-forecast/PaymentForecastPage'));

export const paymentForecastRoutes = [
    {
        path: 'payment-forecast',
        element: <PaymentForecastPage />,
    },
];
